import { render } from "./CustomerWaitlistDetailsEditView.vue?vue&type=template&id=45e82363&scoped=true&ts=true&lang=pug"
import script from "./CustomerWaitlistDetailsEditView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomerWaitlistDetailsEditView.vue?vue&type=script&lang=ts&setup=true"

import "./CustomerWaitlistDetailsEditView.vue?vue&type=style&index=0&id=45e82363&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45e82363"]])

export default __exports__